import React from "react";
import { Heart } from "lucide-react";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <span
      className={`inline-flex items-center gap-1.5 select-none ${className}`}
    >
      <span className="text-2xl font-bold tracking-tighter font-serif">
        Wellness
      </span>

      <div className="relative flex items-center justify-center">
        <Heart className="text-accent fill-accent" size={26} />
        <span className="absolute text-[10px] font-bold text-accent-foreground font-serif pb-0.5">
          by
        </span>
      </div>

      <span className="text-2xl font-bold tracking-tighter font-serif">
        Mercy
      </span>
    </span>
  );
};

export default Logo;
